import React from "react";
import api from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";

export default function ImpersonationBanner() {
  const { user } = useAuth();
  if (!user?.impersonated) return null;

  const stop = async () => {
    try { await api.post("/auth/stop-impersonation"); } catch {}
    window.location.assign("/super/dashboard");
  };

  return (
    <div className="fixed top-3 inset-x-0 z-50 flex justify-center pointer-events-none px-3">
      <div className="pointer-events-auto bg-indigo-600 text-white rounded-full shadow-lg px-5 py-2 text-sm flex items-center gap-3" data-testid="global-impersonation-banner">
        <span className="inline-block w-2 h-2 rounded-full bg-amber-300 animate-pulse" />
        運営者による代理ログイン中 ({user.name})
        <button onClick={stop} data-testid="global-stop-impersonation-btn" className="ml-2 rounded-full bg-white/15 hover:bg-white/25 px-3 py-1 text-xs font-semibold">解除する</button>
      </div>
    </div>
  );
}
